import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import oauth from "../constants/OAuth2";
import * as oauthActionCreators from "../redux/modules/auth";
import { loading } from "./Alert";
import { getUrlParams } from "../constants/utils";

const {
  url,
  authorizationPath,
  clientId,
  redirectUri,
  galleryRedirect,
  responseType,
  scope,
} = oauth;

class OAuth2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggingIn: false
    };
  }

  componentDidMount() {
    this.handleLogin();
  }

  handleLoginSuccess = (code) => {
    localStorage.setItem("lastLoginCode", code);
    window.location.href = window.location.pathname;
  }

  handleLogin = async () => {
    if (this.state.isLoggingIn) {
      return;
    }

    const { login } = this.props;
    const urlParams = getUrlParams();
    const urlCode = urlParams.code;
    const urlSource = urlParams.source;

    if (urlSource === "port-dakika") {
      if (urlCode && urlCode !== "undefined") {
        this.setState({ isLoggingIn: true });
        localStorage.removeItem('oauth2Token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expireDate');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('code');
        localStorage.removeItem('tokenExpired');
        localStorage.removeItem('lastLoginCode');
        localStorage.setItem("code", urlCode);
        loading();
        try {
          await login({ code: urlCode, redirectUrl: redirectUri });
          this.handleLoginSuccess(urlCode);
        } catch (e) {
          console.log(e);
          this.setState({ isLoggingIn: false });
        }
      } else {
        window.location = `${
          url + authorizationPath
        }?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
      }
    } else {
      if (urlCode && urlCode !== "undefined") {
        this.setState({ isLoggingIn: true });
        localStorage.removeItem('oauth2Token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expireDate');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('code');
        localStorage.removeItem('tokenExpired');
        localStorage.removeItem('lastLoginCode');
        localStorage.setItem("code", urlCode);
        loading();
        try {
          await login({ code: urlCode, redirectUrl: redirectUri });
          this.handleLoginSuccess(urlCode);
        } catch (e) {
          console.log(e);
          this.setState({ isLoggingIn: false });
        }
      } else {
        const referrer = document.referrer;
        let customRedirectUri = galleryRedirect;

        if (referrer.includes(galleryRedirect)) {
          customRedirectUri = redirectUri;
        }

        window.location = `${
          url + authorizationPath
        }?response_type=${responseType}&client_id=${clientId}&redirect_uri=${customRedirectUri}&scope=${scope}`;
      }
    }
  }

  render() {
    return <div />;
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...oauthActionCreators }, dispatch);
export default withRouter(connect(null, mapDispatchToProps)(OAuth2));



// WEBPACK FOOTER //
// ./src/helpers/OAuth2.js